import React from 'react';
import PropTypes from 'prop-types';
import withCookieConsentSocialMedia from './withCookieConsentSocialMedia';
import { FacebookEmbed } from 'react-social-media-embed';

// Providing minimal width, responsiveness will be handled by CSS.
const BBSocialMediaEmbedFacebook = ({ postURL }) => (
  <div>
    <FacebookEmbed url={postURL} width="auto" />
  </div>
);

BBSocialMediaEmbedFacebook.propTypes = {
  postURL: PropTypes.string.isRequired,
};

export default withCookieConsentSocialMedia(BBSocialMediaEmbedFacebook);
